import { createFileRoute } from "@tanstack/react-router";

import { routeHead, SITE_URL } from "@/lib/seo-head";
import Blog from "@/pages/Blog";

export const Route = createFileRoute("/blog")({
  head: () =>
    routeHead({
      path: '/blog',
      title: "Blog | Conseils architecture d'intérieur à Lyon",
      description: "Conseils et retours d'expérience de JIIA Studio : aménagement, rénovation, couleur, plans 2D/3D et budgets de chantier.",
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Accueil", item: SITE_URL },
          { "@type": "ListItem", position: 2, name: "Blog", item: `${SITE_URL}/blog` },
        ],
      },
    }),
  component: Blog,
});
